<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Survey
      {{
        $route.params.editObject
          ? $route.params.action[0].toUpperCase() +
            $route.params.action.slice(1)
          : ""
      }}
      <div slot="right">
        <b-button
          v-if="survey._state != 'completed' && survey.mode != 'display'"
          type="is-primary import-button"
          @click="saveAsDraft"
          >&nbsp;Save as Draft</b-button
        >
        <b-button
          v-if="survey._state == 'completed'"
          type="is-primary import-button"
          @click="retrySurvey"
          >&nbsp;Run Survey Again</b-button
        >
        <b-button
          type="is-normal import-button"
          @click="downloadSurvey"
          v-if="survey_id"
          >&nbsp;Download as PDF</b-button
        >
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <div v-if="JSON.stringify(survey) != '{}'">
        <Survey :survey="survey" />
      </div>
      <div v-if="survey._state == 'Submitted'" class="navigation-block"></div>
    </section>
  </div>
</template>

<script>
import HeroBar from "@/components/HeroBar";
import TitleBar from "@/components/TitleBar";
import { Survey, Model, StylesManager } from "survey-vue";
import "survey-vue/defaultV2.css";
StylesManager.applyTheme("defaultV2");
import utitlityMixin from "@/mixins/UtilityMixin";
import { mapGetters } from "vuex";
import RAMSurveyService from "@/services/RAMSurveyService";
export default {
  components: {
    Survey,
    HeroBar,
    TitleBar
  },
  props: {
    surveyId: {
      type: String,
      default: null
    },
    editObject: {
      type: Object,
      default: null
    }
  },
  mixins: [utitlityMixin],
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "isUserExternal",
      "mappedCustomer",
      "switchCustomerView"
    ]),
    titleStack() {
      return [{ url: "#", name: "Survey" }];
      //return ["Country Assignment"];
    },
    packegingId() {
      if (this.$route.params.editObject) {
        if (this.$route.params.action == "edit") {
          return this.$route.params.editObject.id;
        }
      }
      return null;
    }
  },
  watch: {
    surveyId: function(newVal, oldVal) {
      if (newVal != null) {
        this.survey_id = newVal;
      }
    }
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    if (this.mappedCustomer && this.mappedCustomer.length > 0) {
      this.switchCustomerId = this.mappedCustomer[0];
    }
    if (this.$route.params.editObject) {
      this.survey_id = this.$route.params.editObject.id;
    }
    this.getProductList();
  },
  methods: {
    downloadSurvey() {
      try {
        this.surveyService.downloadSurvey(
          this.switchCustomerId,
          this.survey_id
        );
      } catch (e) {
        this.handleApiError;
      }
    },
    retrySurvey() {
      this.survey.clear();
      this.survey.render();
    },
    saveAsDraft() {
      this.surveyService
        .saveSurveyData(
          this.switchCustomerId,
          this.ramSurveyId,
          this.survey.data,
          "Draft",
          this.packegingId
        )
        .subscribe(response => {
          this.survey_id = response.id;
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Survey is saved as draft successfully!"
          });
        }, this.handleApiError);
    },
    getProductList() {
      this.surveyService.getAllProductList(this.switchCustomerId).subscribe(
        response => {
          const productList = response.map(product => {
            return product.product_name;
          });
          this.getData(productList);
        },
        error => {
          console.log(error);
        }
      );
    },
    getData(productList, id) {
      this.surveyService.getSurveyData(this.switchCustomerId, id).subscribe(
        response => {
          response = response[0];
          this.surveyJson = response.question_data;
          this.ramSurveyId = response.id;
          response.question_data.pages[0].elements[1].choices = productList;
          response.question_data.pages[0].elements[1].type = "tagbox";
          const model = new Model(response.question_data);
          model.onComplete.add(this.saveResults);
          this.survey = model;
          if (this.survey._state == "Submitted") {
            this.survey.addNavigationItem({
              id: "survey_save_as_file",
              title: "Save as PDF",
              action: () => {
                this.saveSurveyToPdf("surveyResult.pdf", this.survey);
              }
            });
          }
          if (this.$route.params.editObject) {
            this.survey.data = this.$route.params.editObject.result_data;
            if (this.$route.params.action == "view") {
              this.survey.readOnly = true;
              this.survey.mode = "display";
            }
          }
        },
        error => {
          console.log(error);
        }
      );
    },
    handleApiError(reason) {
      this.isLoading = false;
      let errorMessage = null;
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        } else {
          errorMessage = "Invalid input";
        }
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
        //onConfirm: () => this.redirectToReport()
      });
    },
    saveResults(survey) {
      let id = null;
      // if (this.$route.params.editObject) {
      //   id = this.$route.params.editObject.id;
      // }
      id = this.ramSurveyId;
      this.surveyService
        .saveSurveyData(
          this.switchCustomerId,
          id,
          survey.data,
          "Submitted",
          this.packegingId
        )
        .subscribe(response => {
          this.survey_id = response.id;
          this.survey._state = "Submitted";
        }, this.handleApiError);
    }
  },
  data() {
    return {
      switchCustomerId: null,
      survey: {},
      survey_id: null,
      ramSurveyId: null,
      surveyJson: {},
      surveyService: new RAMSurveyService()
    };
  }
};
</script>

<!-- <script>
export default {
  name: 'NotFound',
  
}
</script> -->
